package one.healthium.uscreen.serialization

import kotlinx.serialization.KSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.descriptors.buildClassSerialDescriptor
import kotlinx.serialization.descriptors.element
import kotlinx.serialization.encoding.CompositeDecoder
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.encoding.decodeStructure
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import one.healthium.uscreen.domain.models.PlatformText

object PlatformTextSerializer : KSerializer<PlatformText> {
    override val descriptor: SerialDescriptor =
        buildClassSerialDescriptor("one.healthium.uscreen.domain.models.PlatformText") {}

    override fun deserialize(decoder: Decoder): PlatformText {
        val input = decoder as JsonDecoder
        return when (val element = input.decodeJsonElement()) {
            is JsonPrimitive -> PlatformText(input.json.decodeFromJsonElement(String.serializer(), element))
            is JsonObject -> input.json.decodeFromJsonElement(PlatformTextObjectSerializer, element)
            else -> error("Unexpected JSON element for PlatformText")
        }
    }

    override fun serialize(encoder: Encoder, value: PlatformText) {
        if (value.android == value.ios) {
            encoder.encodeString(value.android)
        } else {
            PlatformTextObjectSerializer.serialize(encoder, value)
        }
    }
}

private object PlatformTextObjectSerializer : KSerializer<PlatformText> {
    override val descriptor: SerialDescriptor =
        buildClassSerialDescriptor("PlatformTextObject") {
            element<String>("android")
            element<String>("ios")
        }

    override fun deserialize(decoder: Decoder): PlatformText {
        return decoder.decodeStructure(descriptor) {
            var android: String? = null
            var ios: String? = null
            while (true) {
                when (val index = decodeElementIndex(descriptor)) {
                    0 -> android = decodeStringElement(descriptor, 0)
                    1 -> ios = decodeStringElement(descriptor, 1)
                    CompositeDecoder.DECODE_DONE -> break
                    else -> error("Unexpected index: $index")
                }
            }
            requireNotNull(android) { "PlatformText requires 'android' field" }
            requireNotNull(ios) { "PlatformText requires 'ios' field" }
            PlatformText(android = android, ios = ios)
        }
    }

    override fun serialize(encoder: Encoder, value: PlatformText) {
        encoder.beginStructure(descriptor).apply {
            encodeStringElement(descriptor, 0, value.android)
            encodeStringElement(descriptor, 1, value.ios)
            endStructure(descriptor)
        }
    }
}
